import { useTheme } from '@bct/styleguide';
import { useEffect, useRef } from 'react';

const STORAGE_KEY = 'pregoo-dark-mode';

/**
 * Persists the styleguide's dark mode preference across reloads.
 *
 * The @bct/styleguide ThemeProvider always initializes isDarkMode to false
 * and does not persist the choice itself, so without this sync the theme
 * would reset to light on every refresh.
 */
export function DarkModeSync() {
  const { isDarkMode, toggleDarkMode } = useTheme();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'true' && !isDarkMode) {
      toggleDarkMode();
    } else if (saved === 'false' && isDarkMode) {
      toggleDarkMode();
    }
  }, [isDarkMode, toggleDarkMode]);

  useEffect(() => {
    if (!initialized.current) return;
    localStorage.setItem(STORAGE_KEY, String(isDarkMode));
  }, [isDarkMode]);

  return null;
}
